import { render } from "./AllSubmissionsView.vue?vue&type=template&id=77e3df3b"
import script from "./AllSubmissionsView.vue?vue&type=script&lang=js"
export * from "./AllSubmissionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__